$(document).ready(function(){
 $('.r_span').attr('rowspan', '3');
 $('body').on('click','.sidebar-filter .sidebar-tags .apply__button',function(e){
   e.preventDefault();
   $('#CollectionFiltersForm .close-sidebar').trigger('click');
 });

   $('body').on('keyup', '.is_gift_wrap_msg',function(e){
    e.preventDefault();
    $('.limit_text').remove();
    var pending = 300 - $(this).val().length;
    $('.gift_note_wrp').append('<div class="limit_text">'+ pending + ' character(s) left </div>');
  });
  $('body').on('change', '.is_gift_wrap_msg',function(e){
    e.preventDefault();
    var val = $(this).val();
    $.ajax({
        url: "".concat("/cart/update.js"),
        type: 'POST',
        data: {"attributes[gift-message-note]": val},
        success: function(result) { 
            ella.loadAjaxCart();
        },
        error: function(jqxhr, status, exception) {
            console.log(exception);
        }
    });
  });
  $('body').on('change','input[name="set_gift_wrap"]',function(e){
    e.preventDefault();
    var var_input = Number($(this).attr('data-variant_id'));
    if(typeof var_input !== 'undefined' && var_input != null && var_input != ''){
      if($(this).is(':checked')){
        if(!$('.CartItem[data-variant_id="'+ var_input +'"]').length){
          var data = [];
          var items = {};
          items.id = var_input;
          items.quantity = 1;
          data.push(items);
          $.post("".concat("/cart/add.js"), {
            items: data
          }, function(c){
            ella.loadAjaxCart();
          },'JSON').fail(function(response) {
            console.log('In error');
          });
        }
      }else if($('.CartItem[data-variant_id="'+ var_input +'"]').length){
        var cline = $('.CartItem[data-variant_id="'+ var_input +'"]').attr('data-line');
        var cdata = {
          line: cline,
          quantity: 0,
        }; 
        fetch("".concat("/cart/change.js"), {
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(cdata),
        }).then(data => {
          $.ajax({
              url: "".concat("/cart/update.js"),
              type: 'POST',
              data: {"attributes[gift-message-note]": ""},
              success: function(result) { 
                  console.log('done');
                  ella.loadAjaxCart();
              },
              error: function(jqxhr, status, exception) {
                  ella.loadAjaxCart();
              }
          });
        })
      }
    }
  });
  
});

// $(document).ready(function(){
  
//   $(document).on('click','.add-to-cart-btn', function(e){
//     alert('k');
//     e.preventDefault();
// var variant_id = $(this).find('input[name="id"]').val();
//     addItemToCart(variant_id, 1);   // paste your id product number
//   });
  

//   function addItemToCart(variant_id, qty) {
//     data = {
//       "id": variant_id,
//       "quantity": qty
//     }
    
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       dataType: 'json',
//       success: function() { 
// //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
// //           bubbles: true  //this code is for prestige theme, is to refresh the cart
// //        }));
//       }
//     });
// //     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
// //     	bubbles: true    // same code for prestige theme   
// //  	 }));
//   }
// });